module.exports = __webpack_public_path__ + "img/flag-PY.6b984e61.png";